import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("impec_token");
    if (!token) { setChecking(false); return; }
    api.get("/auth/me")
      .then(({ data }) => setAdmin(data))
      .catch(() => localStorage.removeItem("impec_token"))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("impec_token", data.access_token);
    setAdmin({ email: data.email, role: "admin" });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("impec_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
